import { ERROR_REPORT, LOADING_REPORT, GET_REPORT, PUT_REPORT, POST_REPORT, LIST_REPORT, DELETE_REPORT } from "../constants";
import { ReportResponse, UserReportResponse } from "../../types/report";

const initial_state = {
  loading: false,
  error: null,
  list: [] as ReportResponse[],
  user_reports: {
    list: [] as UserReportResponse[]
  },
};

interface stateOptions {
  type: string;
  payload?: any;
}

export default function Report(state = initial_state, { type, payload }: stateOptions) {
  switch (type) {
    case ERROR_REPORT:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case LOADING_REPORT:
      return {
        ...state,
        loading: true,
      };

    case GET_REPORT:
      return {
        ...state,
        loading: false,
        user_reports: {
          list: payload
        }
      };

    case PUT_REPORT:
      return {
        ...state,
        loading: false,
        user_reports: {
          list: state.user_reports.list.concat([payload.results])
        }
      }

    case POST_REPORT:
      return {
        ...state,
        loading: false,
        user_reports: {
          list: payload.results
        }
      }
    
    case LIST_REPORT:
      return {
        ...state,
        loading: false,
        list: payload
      }

    case DELETE_REPORT:
      const removeId = payload.reportId;

      return {
        ...state,
        loading: false,
        user_reports: {
          list: removeId ? state.user_reports.list.filter(user_report => user_report.report.id !== removeId) : []
        }
      }

    default:
      return state;
  }
}
